var Audio = require('../lib/audio');
var audios = {
    stomp: new Audio('/audio/28nov/titrisation-tampon-03.mp3', { channel: 'frame' } )
};

var stampFrames = {
    '1': [1, 3, 5, 7],
    '2': [0, 4, 5, 6, 8],
    '3': [0, 1, 3, 4, 7]
};

module.exports = {
    onStomperFrameUpdate: function(frameIndex, intensity, stamp)
    {
        var stampFramesFromIntensity = _.get(stampFrames, intensity, []);
        if (stampFramesFromIntensity.indexOf(frameIndex) >= 0)
        {
            _.get(audios, 'stomp').play();

            TweenMax.fromTo(stamp, 0.4, {
                alpha: 1
            },{
                alpha: 0,
            });
        }
    }
};



// WEBPACK FOOTER //
// ./js/animations/puppetsMaster.js